import {Injectable} from '@angular/core';
import {HttpService} from '../http.service';

/**
 * Functions to control a SandenVendo Warenautomat machine.
 */
@Injectable({
	providedIn: 'root'
})
export class VemioApi extends HttpService {

	/**
	 * Gets the sensor data of the VEMIO board in human-readable, translated format.
	 */
	async getSensorValues(): Promise<{ [p: string]: string }> {
		return await this.get<{ [sensorID: string]: string }>('vemio/sensorvalues');
	}

}
